module.exports = __webpack_public_path__ + "img/alberto-beingolea.2caebb82.png";